export default "__VITE_ASSET__44a90289__"